<template>
  <div class="flex flex-wrap items-center justify-around">
    <div
      v-for="(cast, index) in Array(10).fill()"
      :key="index"
      class="w-32 p-2 my-4"
    >
      <div class="ssc-wrapper bg-secondary shadow">
        <div class="h-48 shaddow">
          <div class="ssc-square mb w-full h-full"></div>
        </div>
        <div class="bg-secondary p-2 h-20">
          <div class="w-16 my-2">
            <div class="ssc-line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
